import React, { useState, useEffect } from "react";
import { RiArrowRightDoubleLine } from "react-icons/ri";
import { toast } from "react-toastify";
import "./CouponCode.css";
import { BASE_URL } from "../../constant";
import axios from "axios";
function CouponCode() {
  const [coupon, setCoupon] = useState([]);
  const [homePageCouponText, setHomePageCouponText] = useState({
    text1: null,
    text2: null,
    text3: null,
    text4: null,
  });
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/coupons/is-main`)
      .then((response) => {
        const fetchedCoupon = response.data;
        setCoupon(fetchedCoupon);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch coupon code: ", error);
      });
    fetchHomePageCouponText();
  }, []);
  const fetchHomePageCouponText = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/home-coupons`);
      const homeCoupons = response.data;
      console.log(homeCoupons);
      const couponTextMap = homeCoupons.reduce((acc, coupon) => {
        const couponObj = JSON.parse(coupon.couponText);
        acc[`text${coupon.position}`] = couponObj.couponText;
        return acc;
      }, {});

      setHomePageCouponText(couponTextMap);
    } catch (error) {
      console.error("Error fetching home page coupon text:", error);
    }
  };
  const handleCouponCodeClick = () => {
    const textToCopy = coupon.couponName;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          toast.success("Code Copied");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          fallbackCopyTextToClipboard(textToCopy);
        });
    } else {
      fallbackCopyTextToClipboard(textToCopy);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        toast.success("Code Copied");
      } else {
        toast.error("Failed to copy code");
      }
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
      toast.error("Failed to copy code");
    }

    document.body.removeChild(textArea);
  };

  return (
    <div className="couponcode-container">
      <div className="couponcode-textcontainer">
        {homePageCouponText.text1 && <span>{homePageCouponText.text1}</span>}
        {homePageCouponText.text2 && <span>{homePageCouponText.text2}</span>}
        {homePageCouponText.text3 && <span>{homePageCouponText.text3}</span>}
        {homePageCouponText.text4 && <span>{homePageCouponText.text4}</span>}
      </div>
      <div className="couponcode-arrow">
        <RiArrowRightDoubleLine />
      </div>
      <div className="couponcode-buttoncontainer">
        <button onClick={handleCouponCodeClick}>
          {coupon.couponName ? coupon.couponName : "FIRST"}
        </button>
      </div>
    </div>
  );
}

export default CouponCode;
